import React from 'react';
import PropTypes from 'prop-types';
import LWDialog from 'components/legacy/LWDialog';
import Box from '@material-ui/core/Box';

import AbandonCartModalContents from 'components/legacy/cart/AbandonCartModalContents';
import ConfigSelectModalContents from 'pages/shop/BasketItemWizard/ProductConfig/dropdownDialogs/ConfigSelectModalContents';
import CreateNewCartModalContents from 'pages/shop/dialogs/CreateNewCartModalContents';
import DeleteDNSZoneDialogContents1 from 'pages/domains/details/dns/dialogs/DeleteDNSZoneDialogContents1';
import DeleteDNSZoneDialogContents2 from 'pages/domains/details/dns/dialogs/DeleteDNSZoneDialogContents2';
import DetourDialogContent from 'components/legacy/DetourDialogContent';
import FavoritesListDialogContents from 'components/legacy/FavoritesList/FavoritesListDialogContents';
import HostnameSelection from 'components/legacy/cart/Item/HostnameSelection';
import MasqueradeModalContents from 'components/legacy/cart/MasqueradeModalContents';
import OpportunityModalContents from 'components/legacy/CartBadge/OpportunityModalContents';
import CreateAdminCartDialogContents from 'components/legacy/CreateAdminCartDialogContents';
import EditCartDetailsDialogContents from 'components/legacy/EditCartDetailsDialogContents';
import PrivateParentNameDialogContents from 'components/legacy/PrivateParentNameDialogContents';
import ServerShutdownDialogContents from 'pages/servers/details/ServerShutdown/ServerShutdownDialogContents';
import ServerStartDialogContents from 'pages/servers/details/ServerStart/ServerStartDialogContents';
import CreateLoadBalancer from 'pages/services/LoadBalancersContainer/Dialogs/CreateLoadBalancer';

import {
	contentKeyToTitleMap,
	contentKeyToAddPadding,
	contentKeyToColor,
} from './maps';

const ContentFromKey = ({ contentKey, contentProps }) => {
	const Component = (() => {
		switch (contentKey) {
			case 'AbandonCartModalContents':
				return AbandonCartModalContents;
			case 'ConfigSelectModalContents':
				return ConfigSelectModalContents;
			case 'CreateNewCartModalContents':
				return CreateNewCartModalContents;
			case 'DeleteDNSZoneDialogContents1':
				return DeleteDNSZoneDialogContents1;
			case 'DeleteDNSZoneDialogContents2':
				return DeleteDNSZoneDialogContents2;
			case 'DetourDialogContent':
				return DetourDialogContent;
			case 'FavoritesListDialogContents':
				return FavoritesListDialogContents;
			case 'HostnameSelectionDialog':
				return HostnameSelection;
			case 'PrivateParentNameDialog':
				return PrivateParentNameDialogContents;
			case 'MasqueradeModalContents':
				return MasqueradeModalContents;
			case 'OpportunityModalContents':
				return OpportunityModalContents;
			case 'CreateAdminCartDialogContents':
				return CreateAdminCartDialogContents;
			case 'EditCartDetailsDialogContents':
				return EditCartDetailsDialogContents;
			case 'ServerShutdownDialogContents':
				return ServerShutdownDialogContents;
			case 'ServerStartDialogContents':
				return ServerStartDialogContents;
			case 'CreateLoadBalancerContent':
				return CreateLoadBalancer;
			default:
				// eslint-disable-next-line no-console
				console.error(`The content Key, ${contentKey} could not be found.`);
				return <Box />;
		}
	})();
	return <Component {...contentProps} isDialog />;
};

const Dialogs = ({
	onClose, // from connected
	resetDialog, // from connected
	open,
	dialogProps,
	content,
	contentProps,
	contentKey,
	color = contentKeyToColor[contentKey],
	title = contentKeyToTitleMap[contentKey],
	dismissible,
	maxWidth = 'sm',
}) => {
	return (
		<LWDialog
			title={title}
			color={color}
			onClose={onClose}
			open={open}
			maxWidth={maxWidth}
			fullWidth
			{...dialogProps}
			dismissible={dismissible}
			contentPadding={contentKeyToAddPadding[contentKey]}
			resetDialog={resetDialog}
		>
			{
				content ||
					(contentKey ? (
						<ContentFromKey
							contentKey={contentKey}
							contentProps={contentProps}
						/>
					) : null)
				// !TODO figure out why an empty dialog flashes onClose, causing this Fragment to be needed
			}
		</LWDialog>
	);
};

Dialogs.propTypes = {
	/**  */
	title: PropTypes.string,
	/**  function executed to close dialog */
	onClose: PropTypes.func,
	/** from dialogs/reducer */
	open: PropTypes.bool,
	color: PropTypes.string,
	dialogProps: PropTypes.object,
	content: PropTypes.node,
	contentProps: PropTypes.object,
	/**  */
	dismissible: PropTypes.bool,
	/** MUI Prop passed to Dialog */
	maxWidth: PropTypes.string,
};

export default Dialogs;
